import gsap from 'gsap';
import {
    Group, Mesh
} from 'three';
import Text3D from './Text3D';
import { /* SIZE_REFS_MAP, */ SIZE_OPTIONS, SIZE_REFS_MAP } from '../../../constants/sizes';
import { COLOR_DEFAULT_BUTTON_TEXT } from '../../../constants/colors';
import {
    getTextMetrics
} from './metrics/ButtonMetrics';
import { FullHeightRoundedRect } from '../geometries/FullHeightRoundedRect';
import { MaterialsFactory } from '../factories/MaterialsFactory';
import { materialsLib } from '../../../../data/settings';
import { ButtonComponent3D } from './ButtonComponent3D';

export class Button extends ButtonComponent3D {
    #text = '';
    #textG;
    #text3d;
    #backMesh;
    #heightInitial = 1;
    #height = 1;

    constructor(text, clickAction) {
        super(clickAction);

        const { button } = SIZE_REFS_MAP[SIZE_OPTIONS.LANDSCAPE];

        this.#heightInitial = button.height;
        this.#height = button.height;

        const textG = new Group();
        const backMesh = new Mesh(new FullHeightRoundedRect(
            button.width, button.height, 18, 5
        ), MaterialsFactory.create(materialsLib.buttonBackBasic));

        backMesh.position.z = -0.01;
        backMesh.scale.set(1.01, 1.01, 1.01);

        this.add(backMesh);
        this.add(textG);

        this.#text = text;
        this.#backMesh = backMesh;
        this.#textG = textG;
        this._mainClickTarget = backMesh;
    }

    _setup() {
        super._setup();
        this.waitForPreload = true;
        this.hasResize = true;
    }

    _resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio) {
        super._resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio);

        if (orientationChanged) {
            const { button } = SIZE_REFS_MAP[orientation];

            this.#height = button.height;
            const s = button.height / this.#heightInitial;

            this.#backMesh.scale.set(s, s, s);
        }

        if (changed) {
            if (this.#text3d) {
                const metricsTxt = getTextMetrics(orientation);

                this.#text3d.setMetrics({
                    ...metricsTxt
                });
            }
        }
    }

    setupPreloadedContent(infrastructure) {
        const metricsTxt = getTextMetrics(SIZE_OPTIONS.LANDSCAPE);

        const text3d = new Text3D({
            ...metricsTxt,
            color: COLOR_DEFAULT_BUTTON_TEXT,
            valign: 'center'
        }, this.#text, infrastructure);

        this.#textG.add(text3d);

        this.#text3d = text3d;
    }

    get height() {
        return this.#height;
    }

    stop() {
        super.stop();

        gsap.killTweensOf(this.#backMesh.scale);
    }

    setOver() {
        if (!this.visible) return;

        gsap.to(this.#backMesh.scale, {
            x: 1.04,
            y: 1.04,
            duration: 0.25,
            ease: 'pow2.inOut',
            overwrite: 'auto'
        });
    }

    setOut() {
        if (!this.visible) return;

        gsap.to(this.#backMesh.scale, {
            x: 1,
            y: 1,
            duration: 0.45,
            ease: 'elastic.out(1, 0.75)',
            overwrite: 'auto'
        });
    }
}
